import { axiosBase, errorHandler } from "./axios";

const createEnquiryService = (payload:any) => {
    return axiosBase
        .post("api/v1/enquiries/create",payload)
        .then((response) => response.data)
        .catch((err) => errorHandler(err));
};
const listEnquiryService = (payload:any) => {
    return axiosBase
        .post("api/v1/enquiries/list",payload)
        .then((response) => response.data)
        .catch((err) => errorHandler(err));
};
const deleteEnquiryService = (id:string) => {
    return axiosBase
        .delete(`api/v1/enquiries/delete/${id}`)
        .then((response) => response.data)
        .catch((err) => errorHandler(err));
};

const viewEnquiryService = (id:string) => {
    return axiosBase
        .get(`api/v1/enquiries/view/${id}`)
        .then((response) => response.data)
        .catch((err) => errorHandler(err));
};
const updateEnquiryService = ({id,payload}:{id:string,payload:any}) => {
    return axiosBase
        .put(`api/v1/enquiries/update/${id}`, payload)
        .then((response) => response.data)
        .catch((err) => errorHandler(err));
};

export const enquiryService = {
    createEnquiryService,
    listEnquiryService,
    deleteEnquiryService,
    viewEnquiryService,
    updateEnquiryService,
}